<template>
  <div class="relative">
    <nav class="w-full bg-[#0a0d26] flex items-center h-16 shadow-lg md:hidden px-6 fixed top-0 left-0 z-[70] border-b border-white/10">
      <h1 class="text-2xl text-white font-playfair font-semibold absolute left-1/2 transform -translate-x-1/2 whitespace-nowrap">
        Naturel & Joli
      </h1>

      <button 
        @click="toggleDrawer" 
        class="flex flex-col items-center justify-center focus:outline-none ml-auto group"
      >
        <div class="space-y-1.5 bg-white/5 p-2 rounded-lg transition-colors group-hover:bg-white/10">
          <span class="block w-6 h-0.5 bg-white"></span>
          <span class="block w-6 h-0.5 bg-[#cd825b]"></span>
          <span class="block w-4 h-0.5 bg-white ml-auto"></span>
        </div>
      </button>
    </nav>

    <transition name="slide">
      <aside v-if="isDrawerOpen" class="fixed inset-0 z-[80] flex justify-end">
        <div class="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity" @click="toggleDrawer"></div>
        
        <div class="relative w-72 bg-[#0a0d26] h-full shadow-2xl flex flex-col overflow-hidden border-l border-white/10">
          
          <div class="p-6 flex justify-between items-center border-b border-white/10">
            <h1 class="text-xl text-white font-playfair font-bold">Menu</h1>
            <button @click="toggleDrawer" class="w-8 h-8 flex items-center justify-center rounded-full bg-white/5 text-white hover:bg-red-500/20 hover:text-red-400 transition-all">
              ✕
            </button>
          </div>

          <nav class="flex-1 px-4 py-8 space-y-8 overflow-y-auto custom-scrollbar">
            
            <div class="space-y-4">
              <p class="px-4 text-[10px] font-bold uppercase tracking-[0.2em] text-gray-500">Général</p>
              <div class="space-y-2">
                <RouterLink
                  v-for="item in generalMenu"
                  :key="item.label"
                  :to="item.to"
                  @click="toggleDrawer"
                  class="flex items-center gap-4 rounded-xl px-4 py-3 text-sm transition-all duration-200"
                  :class="[
                    $route.path === item.to 
                      ? 'bg-[#cd825b] text-white' 
                      : 'text-gray-400 hover:bg-white/5 hover:text-white'
                  ]"
                >
                  <component :is="item.icon" class="w-5 h-5 flex-shrink-0" />
                  <span class="font-medium leading-none">{{ item.label }}</span>
                </RouterLink>
              </div>
            </div>

            <div class="space-y-4">
              <p class="px-4 text-[10px] font-bold uppercase tracking-[0.2em] text-gray-500">Configuration</p>
              <div class="space-y-2">
                <RouterLink
                  v-for="item in settingsMenu"
                  :key="item.label"
                  :to="item.to"
                  @click="toggleDrawer"
                  class="flex items-center gap-4 rounded-xl px-4 py-3 text-sm transition-all duration-200"
                  :class="[
                    $route.path === item.to 
                      ? 'bg-[#cd825b] text-white' 
                      : 'text-gray-400 hover:bg-white/5 hover:text-white'
                  ]"
                >
                  <component :is="item.icon" class="w-5 h-5 flex-shrink-0" />
                  <span class="font-medium leading-none">{{ item.label }}</span>
                </RouterLink>
              </div>
            </div>
          </nav>

          <div class="p-4 bg-black/20 space-y-4 border-t border-white/10">
            <div class="flex items-center gap-3 bg-white/5 p-3 rounded-2xl">
              <img
                :src="user.photo || `https://ui-avatars.com/api/?name=${user.prenom}+${user.nom}&background=cd825b&color=fff`"
                alt="Photo de profil"
                class="w-10 h-10 rounded-full object-cover ring-2 ring-[#cd825b]/20"
              />
              <div class="min-w-0">
                <p class="text-xs font-bold text-white truncate">{{ user.prenom }} {{ user.nom }}</p>
                <p class="text-[10px] text-gray-500 truncate">{{ user.email }}</p>
              </div>
            </div>

            <button
              @click="logout"
              class="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-red-600/10 text-red-500 hover:bg-red-600 hover:text-white transition-all font-bold text-xs uppercase tracking-widest shadow-sm"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 11-4 0v-1m0-10V5a2 2 0 114 0v1" />
              </svg>
              Déconnexion
            </button>

            <p class="text-[10px] text-center text-gray-600 italic">
              © DATAFUSE 2026
            </p>
          </div>
        </div>
      </aside>
    </transition>
    
    <div class="h-16 md:hidden"></div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";
import DashboardIcon from "./Icons/DashboardIcon.vue";
import UserIcon from "./Icons/UserIcon.vue";
import FolderIcon from "./Icons/FolderIcon.vue";
import FileIcon from "./Icons/FileIcon.vue";
import GearIcon from "./Icons/GearIcon.vue";

export default {
  components: { RouterLink, DashboardIcon, UserIcon, FolderIcon, FileIcon, GearIcon },
  data() {
    return {
      isDrawerOpen: false,
      user: {
        prenom: "Enzo",
        nom: "Viana",
        email: "enzo.viana@example.com",
        photo: null,
      },
      generalMenu: [
        { label: "Dashboard", to: "/", icon: "DashboardIcon" },
        { label: "Calendrier", to: "/calendar", icon: "FolderIcon" },
        { label: "Clients", to: "/clients", icon: "UserIcon" },
        { label: "Catégories", to: "/catégorie", icon: "GearIcon" },
        { label: "Services", to: "/services", icon: "FileIcon" },
      ],
      settingsMenu: [
        { label: "Paramètres", to: "/parametre", icon: "GearIcon" },
      ],
    };
  },
  methods: {
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
      // Empêcher le scroll du body quand le menu est ouvert
      document.body.style.overflow = this.isDrawerOpen ? 'hidden' : '';
    },
    logout() {
      // Logique de déconnexion
      localStorage.clear();
      window.location.href = "/login";
    }
  },
};
</script>

<style scoped>
.font-playfair {
  font-family: 'Playfair Display', serif;
}

/* Animation Slide de la droite */
.slide-enter-active, .slide-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-enter-from, .slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 3px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(205, 130, 91, 0.3);
  border-radius: 10px;
}
</style>